/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

/**
 * Wraps the useEffect hook.
 *
 * The useEffect hook is provided an empty array for then dependencies to force the effect function to only fire once.
 * @param {function} func The function to execute within a useEffect hook.
 */
export function useEffectOnce(func) {
  useEffect(func, []);
}
